import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useClient} from "../../utils/hooks";

export type TRecording = {
  id: number;
  userId: number;
  eventId: number;
  duration: string;
  bookingType: string;
  serviceName: string;
  recording: string;
  createdAt: Date;
  updatedAt: Date;
};
export type TGetRecordingsApiResponse = {
  recordings: TRecording[];
  total?: number;
  hasNextPage?: boolean;
  hasPrevPage?: boolean;
};
const useGetRecordings = () => {
  const client = useClient("RECORDINGS");

  return useQuery<
    TGetRecordingsApiResponse,
    AxiosError<{status: boolean; message: string}>
  >({
    queryKey: ["recordings"],
    queryFn: async () => {
      const res = await client(`recordings`);
      const payload = (res as any)?.data ?? res;
      const page = payload?.data ?? {};
      return {
        recordings: page.data ?? [],
        total: page.total ?? 0,
        hasNextPage: !!page.hasNextPage,
        hasPrevPage: !!page.hasPrevPage,
      };
    },
  });
};

export {useGetRecordings};
